import { BUTTON_VARIANTS } from "@/constants"
import React, { useState } from "react"
import Button from "@/components/common/Buttons/Button"
import { getPropSafely } from "@/utils/utils"
import SubmissionModal from "@/components/Forms/SubmissionModal"
import useGlobals from "@/hooks/useGlobals"
import { useRouter } from "next/router"

function useCancelSubscription() {
	const [response, setResponse] = useState(null)
	const [isLoading, setIsLoading] = useState(false)
	const router = useRouter()

	async function cancelSubscription() {
		setIsLoading(true)
		const originSubscriptionId = router.query.originSubscriptionId
		const hash = router.query.hash
		const provider = router.query.provider

		if (!originSubscriptionId || !hash || !provider) return

		const url = new URL(`${process.env.NEXT_PAYMENT_URL}${provider}/cancel-subscription`)
		url.searchParams.append("originSubscriptionId", originSubscriptionId)
		url.searchParams.append("hash", hash)

		try {
			const response = await fetch(url, {
				method: "DELETE",
				headers: {
					"X-Organization": process.env.X_ORGANIZATION_HEADER,
				},
			})

			setResponse(await response.json())
			setIsLoading(false)
		} catch (error) {
			console.log(error)
			setIsLoading(false)
		}
	}

	return { cancelSubscription, response, isLoading }
}

export default function CancelSubscriptionButton({ data, width }) {
	const router = useRouter()
	const text = getPropSafely(data, "text")
	const [modalOpen, setModalOpen] = useState(false)

	const { modalSuccessText, modalButtonText, modalIcon } = useGlobals((state) => ({
		modalSuccessText: state.cancelSubscriptionModalSuccessText,
		modalErrorText: state.cancelSubscriptionModalErrorText,
		modalButtonText: state.cancelSubscriptionModalButtonText,
		modalIcon: state.cancelSubscriptionModalIcon,
	}))

	const { cancelSubscription, isLoading } = useCancelSubscription()

	return (
		<div className={`col-desktop-${width}`}>
			<Button
				onClick={async () => {
					setModalOpen(true)
					await cancelSubscription()
				}}
				variant={BUTTON_VARIANTS.PRIMARY}
			>
				{text}
			</Button>

			<SubmissionModal
				modalOpen={modalOpen}
				setModalOpen={setModalOpen}
				modalData={{
					closeButtonText: modalButtonText,
					header: modalSuccessText,
					icon: modalIcon || {},
				}}
				loading={isLoading}
				closeModalCallback={() => {
					router.push("/")
				}}
			/>
		</div>
	)
}
